import { type FC, useMemo } from 'react';
import { uiStyles } from '@/lib/ui';
import { UiProgress, type UiProgressProps } from '@/lib/ui/Progress';
import { useRegisterGroupSteps } from '@/registration/hook/useRegisterGroupSteps';

export interface ProgressBarProps extends UiProgressProps {
}

const GroupProgressBar: FC<ProgressBarProps> = ({
  ...props
}) => {
  const { steps, stepIndex } = useRegisterGroupSteps();
  const progressValue = useMemo(
    () => {
      if (steps && Array.isArray(steps) && steps.length > 0 && stepIndex >= 0) {
        return Math.round((stepIndex / steps.length) * 100);
      }
      return 0;
    },
    [steps, stepIndex]
  );

  return (
    <UiProgress
      // size={{base: 'xs', lg: 'sm'}}
      size={'xs'}
      borderRadius={uiStyles.borderRadius}
      colorScheme={'primary'}
      value={progressValue}
      // shadow={uiStyles.cardShadow}
      {...props}
    />
  );
};

export default GroupProgressBar;
